import React from 'react';
import { DataLayer, Feature, InfoWindow } from 'google-react-maps';
import * as Api from 'api';

class CanvassingRegions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      results: []
    }
  }
  refresh = () => {
    Api
      .fetchCanvassingRegion()
      .then(({ results }) => {
        if(this.mounted) {
          this.setState({ results });
        }
      });
  }
  componentDidMount() {
    this.mounted = true;
    this.refresh();
  }
  componentWillUnmount() {
    this.mounted = false;
  }
  render() {
    const { map, maps, fillOpacity } = this.props;
    const { results, infoWindowCoords, infoRegion } = this.state;
    return (
      <div>
        {results.map(region => (
          <DataLayer
            visible
            key={region._id}
            map={map}
            maps={maps}
          >
            {region.features.map(feature => (
              <Feature
                id={feature._id}
                key={`${region._id}-${feature._id}`}
                onClick={event => this.setState({ infoWindowCoords: event.coords, infoRegion: region })}
                geoJson={{
                  ...feature,
                  properties: {
                    ...feature.properties,
                    fillOpacity: typeof fillOpacity === 'number'? fillOpacity : 0.3
                  }
                }}
              />
            ))}
          </DataLayer>
        ))}
        {infoRegion ? (
          <InfoWindow
            map={map}
            maps={maps}
            coords={infoWindowCoords}
            open={true}
            onCloseClick={e => this.setState({ infoWindowCoords: null, infoRegion: null })}
          >
            <div>
              <h3>{infoRegion.name}</h3>
              <p>Assigned to: {infoRegion.assigned_to_users.map(user => user.name && user.name.first && user.name.last ? `${user.name.first} ${user.name.last}${ user.email ? ` (${user.email})` : ''}` : user.email).join(',')}.</p>
            </div>
          </InfoWindow>
        ) : null}
      </div>
    );
  }
}

export default CanvassingRegions;



// WEBPACK FOOTER //
// ./src/browser/components/clients/map/canvassing-regions.js